import React from 'react'
import "./Gaming.css"
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { green } from '@mui/material/colors';

function gaming() {
  return (
    <div className="main">
      <div className='status'>
        <h1>青鬼ごっこ</h1>
        <div className="desc">
          <CheckCircleIcon className='CheckCircleIcon' sx={{ color: green[500] }} />
          <span>ゲーム中です</span>
        </div>
      </div>
    </div>
  )
}

export default gaming